import { IonIcon, IonLabel, IonPopover, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';
import Estimates from '../pages/Estimates';
import Debug from '../pages/Debug';
import List from '../pages/List';
import AddNote from '../pages/AddNote';
import JobNotes from '../pages/JobNotes';
import JobExpenses from '../pages/JobExpenses';
import JobChecklist from '../pages/JobChecklist';
import JobChecklists from '../pages/JobChecklists';
import Property from '../pages/Property';
import NewJob from '../pages/NewJob';
import { add, cash, grid, home, time } from 'ionicons/icons';
import React, { useState } from 'react';
import Menu from './Menu';
import JobsContainer from '../pages/JobsContainer';
import JobContainer from '../pages/JobContainer';
import Invoices from '../pages/JobsSelfEmployed/Invoices';
import Bookings from '../pages/Bookings';
import Booking from '../pages/Booking';
import HomePageRedirection from './HomePageRedirection';
import Home from './Home';
import Help from "../pages/Help";
import {useUserPermissions} from "../authorisation/authorisation-hook";

/**
 * Routes available once the user is authenticated.
 */
export default function AppRoutes() {
  const { permissions, roles } = useUserPermissions();

  const [ showPopover, setShowPopover ] = useState(false);
  const [ popoverEvent, setPopoverEvent ] = useState(null);

  return (
    <>
      <IonTabs>
        <IonRouterOutlet>
          {/* TODO: LEGACY AUTH: Remove this line */}
          <Route path="/login" exact component={ () => <Redirect to="/"/> }/>
          <Route path="/help" exact component={ Help }/>

          <Route
            path="/:tab(invoices)"
            exact
            render={ props => {
              if (roles.isSelfEmployed) {
                return (
                  <Invoices { ...props } />
                );
              }

              return (
                <Redirect to={ '/estimates' }/>
              );
            } }
          />
          <Route
            path="/:tab(estimates)"
            exact
            render={ props => {
              if (roles.isSelfEmployed) {
                return (
                  <Redirect to={ '/invoices' }/>
                );
              }

              return (
                <Estimates { ...props } />
              );
            } }
          />
          <Route path="/" exact component={ roles.isCleaner ? Home : HomePageRedirection }/>
          <Route path="/jobs" exact component={ JobsContainer }/>
          <Route path="/debug" exact component={ Debug }/>
          <Route path="/list" exact component={ List }/>
          <Route path="/job/:id" exact component={ JobContainer }/>
          <Route path="/job/:id/addnote" exact component={ AddNote }/>
          <Route path="/job/:id/notes" exact component={ JobNotes }/>
          <Route path="/job/:id/expenses" exact component={ JobExpenses }/>
          <Route path="/job/:id/checklists" exact component={ JobChecklists }/>
          <Route path="/job/:id/checklists/:id2" exact component={ JobChecklist }/>
          <Route path="/property/:id" exact component={ Property }/>
          <Route path="/newjob" exact component={ NewJob }/>
          <Route path="/bookings" exact component={ Bookings }/>
          <Route path="/booking/:id" exact component={ Booking }/>
        </IonRouterOutlet>

        <IonTabBar slot="bottom" key={ roles.isSelfEmployed ? 'self-employed-bar' : 'standard-bar' } color="dteal">
          { roles.isCleaner ? (
            <IonTabButton tab="home" href="/">
              <IonIcon icon={ home }/>
              <IonLabel>home</IonLabel>
            </IonTabButton>
          ) : (
            <IonTabButton tab="jobs" href="/jobs">
              <IonIcon icon={ time }/>
              <IonLabel>jobs</IonLabel>
            </IonTabButton>
          ) }
            
          { permissions.canViewEstimates && (
              <IonTabButton tab="estimates" key="tab-estimates" href="/estimates">
                  <IonIcon icon={ cash }/>
                  <IonLabel>estimates</IonLabel>
              </IonTabButton>
          )}

          { permissions.canViewInvoices && (
              <IonTabButton tab="invoices" key="tab-invoices" href="/invoices">
                  <IonIcon icon={ cash }/>
                  <IonLabel>invoices</IonLabel>
              </IonTabButton>
          )}

            { permissions.canCreateNewJobs && (
              <IonTabButton tab="newjob" href="/newjob">
                  <IonIcon icon={ add }/>
                  <IonLabel>new job</IonLabel>
              </IonTabButton>
          )}

          <IonTabButton tab="menu" selected={ showPopover } onClick={ (e) => {
            e.persist();
            setShowPopover(true);
            setPopoverEvent(e);
          } }>
            <IonIcon icon={ grid }/>
            <IonLabel>menu</IonLabel>
          </IonTabButton>
        </IonTabBar>
      </IonTabs>

      <IonPopover
        isOpen={ showPopover }
        onDidDismiss={ () => setShowPopover(false) }
        event={ popoverEvent }
      >
        <Menu
          dismiss={ () => setShowPopover(false) }
        />
      </IonPopover>
    </>
  );
}
